import { render, staticRenderFns } from "./SuperButton.vue?vue&type=template&id=585a9a1a&scoped=true&"
import script from "./SuperButton.vue?vue&type=script&lang=js&"
export * from "./SuperButton.vue?vue&type=script&lang=js&"
import style0 from "./SuperButton.vue?vue&type=style&index=0&id=585a9a1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585a9a1a",
  null
  
)

export default component.exports